import React from "react";
import { Route, Switch } from "react-router-dom";
import LogInComponent from "./component/Auth/LoginComponent";
import SignupComponenrt from "./component/Auth/SignupComponenrt";
import LogOutComponent from "./component/Auth/LogOutComponent";

import ReferralMaster from "./component/User/userlists/ReferralMaster";
import UserDataComponent from "./component/User/AddUser/UserDataComponent";
import AgentMaster from "./component/User/userlists/AgentMaster";
import InvoiceMaster from "./component/User/userlists/InvoiceMaster";
import TransactionsMaster from "./component/User/userlists/TransactionsMaster";
import OnboardingDashboard from "./component/User/userlists/OnboardingDashboard";
import ChangeAdminPassword from "./component/User/userlists/ChangeAdminPassword";
import ChangeBrokerPassword from "./component/User/userlists/ChangeBrokerPassword";
import CallHistoryListTable from "./component/User/userlists/CallHistoryListTable";
import DownloadAdminMaster from "./component/User/userlists/DownloadAdminMaster";
import InvoiceDownloadMaster from "./component/User/userlists/InvoiceDownloadMaster";
import AddCallComponet from "./component/User/AddCallComponet";

import DashboardComponent from "./component/User/Dashboard/DashboardComponent";
import GuestUserList from "./component/User/Dashboard/GuestUserList";
import Ipo from "./component/User/Dashboard/ipo";
import brokerListComponent from "./component/User/Dashboard/brokerListComponent";
import { PrivateRoute } from "./protected.route";
import NotFound from "./component/Utils/NotFound";



const routes = (
  <Switch>
    <Route exact path="/login" component={LogInComponent}></Route>
    {/* <Route exact path="/signup" component={SignupComponenrt}></Route>  */}
    {/* {/* <PrivateRoute exact path="/" component={AddCallComponet}></PrivateRoute> */}
    <PrivateRoute
      exact
      path="/"
      component={DashboardComponent}
    ></PrivateRoute>
        <PrivateRoute
      exact
      path="/GuestUserList"
      component={GuestUserList}
    ></PrivateRoute>
        <Route
      exact
      path="/Add-new-broker"
      component={Ipo}
    ></Route>
    <Route
      exact
      path="/brokerList"
      component={brokerListComponent}
    ></Route>
    {/* <Route
      exact
      path="/OnboardingDashboard"
      component={OnboardingDashboard}
    ></Route>
    <Route
      exact
      path="/callhistory"
      component={CallHistoryListTable}
    ></Route>
    <Route
      exact
      path="/UserDataComponent"
      component={UserDataComponent}
    ></Route>
        <Route
      exact
      path="/ChangeBrokerPassword"
      component={ChangeBrokerPassword}
    ></Route>
        <Route
      exact
      path="/ChangeAdminPassword"
      component={ChangeAdminPassword}
    ></Route>
            <Route
      exact
      path="/DownloadAdminMaster"
      component={DownloadAdminMaster}
    ></Route>
                <Route
      exact
      path="/AgentMaster"
      component={AgentMaster}
    ></Route>
      <Route
      exact
      path="/ReferralMaster"
      component={ReferralMaster}
    ></Route> */}
          {/* <Route
      exact
      path="/InvoiceMaster"
      component={InvoiceMaster}
    ></Route>
              <Route
      exact
      path="/TransactionsMaster"
      component={TransactionsMaster}
    ></Route>
                  <Route
      exact
      path="/InvoiceDownloadMaster"
      component={InvoiceDownloadMaster}
    ></Route> */}
    <Route exact path="/logout" component={LogOutComponent} />
    <Route exact path="*" component={NotFound} />
  </Switch>
);

export default routes;
